// extracted by mini-css-extract-plugin
module.exports = {"trescat":"globals_trescat__7I5FW","gapBefore":"globals_gapBefore__r0_lv","gapAfter":"globals_gapAfter__cbbBd","noGapAfter":"globals_noGapAfter__pkgjn"};